module.exports = __webpack_public_path__ + "90a0ace246ce5421600f1d3161927684.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-Vrinda.png
// module id = 580
// module chunks = 30